import type { FeatureFlagClient, FeatureFlagRecord, FeatureFlagRegistry } from '@/scopes/common/domain/types';
import featureFlagRegistry from '@/scopes/common/infrastructure/feature-flags/inMemoryFeatureFlagRegistry';
import type { FeatureFlagId } from '@/scopes/common/infrastructure/feature-flags/featureFlags';

export function createFeatureFlagClient<T extends string>(
  initialRegistry: FeatureFlagRegistry<T>
): FeatureFlagClient<T> {
  let registry = initialRegistry;
  return {
    getAll(): FeatureFlagRecord<T> {
      return registry.getAll();
    },
    getActiveList(): T[] {
      return registry.getActiveIdList();
    },
    isActive(id: T) {
      return registry.isActive(id);
    },
    toggle(id: T) {
      registry = registry.isActive(id) ? registry.deactivate(id) : registry.activate(id);
    },
  };
}

export default createFeatureFlagClient<FeatureFlagId>(featureFlagRegistry);
